let connect = require("react-redux").connect;
import React from "react";

let actions = require("../actions/actions");
let ModerationIconCard = require("./moderation-icon-card");

class ModerationIconCards extends React.Component {
    loadMoreUploads() {
        if (!this.props.preview) {
            this.props.fetchUploadIcons(
                "",
                this.props.upload.pagination.icons.pageCount + 1
            );
        } else {
            this.props.previewUploadIcons(
                this.props.upload.id,
                "",
                this.props.upload.pagination.icons.pageCount + 1
            );
        }
    }

    render() {
        let iconArray = [], button = this.renderButton();

        this.props.icons.forEach(icon => {
            iconArray.push(
                <ModerationIconCard
                    key={icon.id}
                    icon={icon}
                    preview={this.props.preview}
                />
            );
        });

        return (
            <section className="icon-card-container row">
                {iconArray}
                {button}
            </section>
        );
    }

    renderButton() {
        let button = null;

        if (
            this.props.upload.pagination &&
            this.props.icons.length !== this.props.upload.icon_count
        ) {
            button = (
                <div style={{ width: "100%" }}>
                    <button
                        className="load-more btn btn-default black"
                        onClick={this.loadMoreUploads.bind(this)}
                    >
                        Load More
                    </button>
                </div>
            );
        }

        return button;
    }
}

module.exports = connect(null, {
    previewUploadIcons: actions.previewUploadIcons,
    fetchUploadIcons: actions.fetchUploadIcons
})(ModerationIconCards);
